module.exports = __webpack_public_path__ + "static/img/product_banner_05_zh.ae7eb42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_05_zh.png
// module id = Jsin
// module chunks = 34